import { createFileRoute } from "@tanstack/react-router";
import { NumbersManagement } from "@/components/numbers-management";

// Update route path to match new location
export const Route = createFileRoute("/_app/$tenantId/numbers")({
  component: NumbersRouteComponent,
});

function NumbersRouteComponent() {
  return <NumbersManagement />;
}
